import { render, staticRenderFns } from "./PointsRecordDetail.vue?vue&type=template&id=5a1d6522&scoped=true"
import script from "./PointsRecordDetail.vue?vue&type=script&lang=js"
export * from "./PointsRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./PointsRecordDetail.vue?vue&type=style&index=0&id=5a1d6522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d6522",
  null
  
)

export default component.exports